<template>
    <div>

        <div :style="style" class="card-container" v-if="control.data.data.type==TYPE_CARD_GREY||control.data.data.type==TYPE_CARD_WHITE||control.data.data.type==TYPE_CARD_WHITE_THUMBNAIL">
            <div v-if="control.data.data.type==TYPE_CARD_WHITE_THUMBNAIL" class="thumbnail">
                <InlineImage :file="generateImageData(control.data.data.image, THUMBNAIL_TYPE_IMAGE)" :width="'46px'" :height="'46px'"></InlineImage>
            </div>
            <div style="text-align: left;margin-left: 10px;flex-grow: 1;">
                <CktextComponent :rawHtml="control.data.data.text"></CktextComponent>
            </div>
            <div class="nav-btn-container">
                <InlinebtnComponent :control="control.data.data.btn" :target="control.data.data.target"></InlinebtnComponent>
            </div>    
        </div>

        <div :style="style" class="card-column-container" v-if="control.data.data.type==TYPE_CARD_BODY_DESCRIPTION">
            <div style="text-align: left;flex-grow: 1;" class="card-body">
                <CktextComponent :rawHtml="control.data.data.text"></CktextComponent>
            </div>
            <div class="card-footer">

                <InlinebtnComponent :control="control.data.data.btn" :target="control.data.data.target"></InlinebtnComponent>

            </div>    
        </div>

        <div :style="overhiddenstyle" class="card-column-container" v-if="control.data.data.type==TYPE_CARD_IMAGE_DESCRIPTION">
            <div style="overflow: hidden;">
                <InlineImage :file="generateImageData(control.data.data.image, THUMBNAIL_TYPE_IMAGE)" :width="'100%'" :height="''"></InlineImage>
            </div>
            <div class="card-text-btn-footer">
                <div>
                    <CktextComponent :rawHtml="control.data.data.text"></CktextComponent>
                </div>

                <InlinebtnComponent :control="control.data.data.btn" :target="control.data.data.target"></InlinebtnComponent>

            </div>    
        </div>

        <div :style="style" class="card-column-container" v-if="control.data.data.type==TYPE_CARD_IMAGE_TEXT_AROUND">
            <div style="text-align: center;">
                <div>
                    <CktextComponent :rawHtml="control.data.data.text"></CktextComponent>
                </div>
            </div>
            <div style="overflow: hidden;border-radius:8px">
                <InlineImage :file="generateImageData(control.data.data.image, THUMBNAIL_TYPE_IMAGE)" :width="'100%'" :height="''"></InlineImage>
            </div>
            <div style="text-align: center;">
                <div>
                    <CktextComponent :rawHtml="control.data.data.text_bottom"></CktextComponent>
                </div>
            </div>
            <div>
                <InlinebtnComponent :control="control.data.data.btn" :target="control.data.data.target"></InlinebtnComponent>
            </div>    
        </div>
            
        <div :style="style" class="card-column-container" v-if="control.data.data.type==TYPE_CARD_IMAGE_DESCRIPTION_UPSIDE">
            <div style="text-align:left">
                <CktextComponent :rawHtml="control.data.data.text"></CktextComponent>
            </div>
            <div style="text-align: left;width: 100%;margin:10px 0px">
                
                <InlinebtnComponent :control="control.data.data.btn" :target="control.data.data.target"></InlinebtnComponent>

            </div> 
            <div style="overflow: hidden;border-radius:8px">
                <InlineImage :file="generateImageData(control.data.data.image, THUMBNAIL_TYPE_IMAGE)" :width="'100%'" :height="''"></InlineImage>
            </div>   
        </div>        
            
        <div :style="overhiddenstyle" class="card-column-container" v-if="control.data.data.type==TYPE_CARD_FULL_IMAGE">
            <div style="overflow: hidden;">
                <InlineImage :file="generateImageData(control.data.data.image, THUMBNAIL_TYPE_IMAGE)" :width="'100%'" :height="''"></InlineImage>
            </div>
            <div class="card-text-btn-footer" style="position:absolute;bottom:5px;background-color: rgba(0,0,0,0.5);">
                <div>
                    <div>
                        <CktextComponent :rawHtml="control.data.data.text"></CktextComponent>
                    </div>
                </div>

                <InlinebtnComponent :control="control.data.data.btn" :target="control.data.data.target"></InlinebtnComponent>

            </div>      
        </div>
    </div>
</template>

<script>

import InlineImage from '../Inlineimage.vue'
import InlinebtnComponent from './Inlinebtn.vue'
import CktextComponent from '../../CkText.vue'

export default {
  name: 'SingleCard',
  components: {
    InlineImage,
    InlinebtnComponent,
    CktextComponent
  },
  data(){
    return {
      style:'',
      overhiddenstyle:'',
      TYPE_CARD_GREY:10,
      TYPE_CARD_WHITE:11,
      TYPE_CARD_WHITE_THUMBNAIL:12,
      TYPE_CARD_BODY_DESCRIPTION:13,
      TYPE_CARD_IMAGE_DESCRIPTION:14,
      TYPE_CARD_IMAGE_TEXT_AROUND:15,
      TYPE_CARD_IMAGE_DESCRIPTION_UPSIDE:16,
      TYPE_CARD_FULL_IMAGE:17,
      THUMBNAIL_TYPE_ICON:1,
      THUMBNAIL_TYPE_IMAGE:2
    }
  },
  props: {
    control: null
  },
  methods:{
    generateImageData(file, type){

        return {fileinfo:file, type:type};

    }
  },
  updated(){

      

  },
  mounted(){


  },
  created(){
    
    this.style=this.$common.generateStyle(this.control.data.style);
    
    //const bgStyle={'background-color':this.control.data.data.background_color};

    //this.style={...style,...bgStyle};

    const ohStyle={'position':'relative','overflow':'hidden'};

    this.overhiddenstyle={...this.style,...ohStyle};

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.thumbnail{
    width: 46px;
    height: 46px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
}
.nav-btn-container{
    flex-shrink: 0;
}
.shadow{
    box-shadow: 0 8px 20px 0px rgb(0 0 0 / 6%), 0 1px 8px rgb(0 0 0 / 4%);     
}
.card-column-container{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}
.card-body{
    border-bottom: 1px solid rgba(120, 130, 140, 0.13);
    padding-bottom: 10px;
}
.card-footer{
    padding-top: 10px;
}
.card-text-btn-footer{
    padding:10px;
    width: calc(100% - 20px);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

</style>
